import React from 'react';
import { Box } from '@material-ui/core';
import * as icons from './icons';

interface IconProps {
  icon: string;
  width?: string | number;
  height?: string | number;
  size?: string | number;

  rotate?: number;
  fill?: string;
  color?: string;
  style?: any;

  onClick?: any;
}

const Icon = ({
  icon,
  width,
  height,
  size,

  rotate,
  fill,
  color,
  style,

  onClick
}: IconProps) => {
  const IconComponent = icons[icon as keyof typeof icons];

  return (
    <Box
      onClick={onClick}
      style={{
        width: width || size,
        height: height || size,
        fill,
        color,
        ...style
      }}
      // rotate={rotate}
    >
      <IconComponent />
    </Box>
  );
};

// const IconWrapper = styled.div<{
//   width?: number;
//   height?: number;
//   rotate?: number;
//   fill?: any;
//   color?: any;
//   styles?: any;
// }>`
//   display: flex;
//   justify-content: center;
//   align-items: center;

//   width: ${({ width }) => width}px;
//   height: ${({ height }) => height}px;

//   ${({ rotate }) =>
//     rotate && {
//       transform: `rotate(${rotate}deg)`,
//     }}
//   svg {
//     width: ${({ width }) => width}px;
//     height: ${({ height }) => height}px;

//     path {
//       stroke: ${({ color }) => colors[color]};
//       fill: ${({ fill }) => colors[fill]};
//     }
//   }

//   ${({ styles }) => css`
//     ${styles}
//   `}
// `;

export default Icon;
